import { render, staticRenderFns } from "./rectificationRecords.vue?vue&type=template&id=7abb7818&scoped=true"
import script from "./rectificationRecords.vue?vue&type=script&lang=js"
export * from "./rectificationRecords.vue?vue&type=script&lang=js"
import style0 from "./rectificationRecords.vue?vue&type=style&index=0&id=7abb7818&prod&lang=scss&scoped=true"
import style1 from "./rectificationRecords.vue?vue&type=style&index=1&id=7abb7818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abb7818",
  null
  
)

export default component.exports